import * as React from "react";
const SvgImageUpload = () => (
  <svg width={50} height={50} fill="none">
    <path
      fill="#6366F1"
      fillRule="evenodd"
      d="M4.167 25c0-9.82 0-14.73 3.05-17.783 3.054-3.05 7.963-3.05 17.783-3.05 9.821 0 14.732 0 17.782 3.05 3.052 3.054 3.052 7.963 3.052 17.783 0 9.821 0 14.732-3.052 17.782-3.048 3.052-7.96 3.052-17.782 3.052-9.82 0-14.73 0-17.783-3.052-3.05-3.048-3.05-7.96-3.05-17.782ZM25 36.98a1.562 1.562 0 0 0 1.563-1.563V24.604l3.583 3.584a1.562 1.562 0 1 0 2.209-2.208l-6.25-6.25a1.563 1.563 0 0 0-2.209 0l-6.25 6.25a1.56 1.56 0 0 0 .48 2.591 1.562 1.562 0 0 0 1.729-.383l3.583-3.583v10.812c0 .862.7 1.563 1.562 1.563Zm-8.333-20.834a1.563 1.563 0 0 1 0-3.125h16.667a1.562 1.562 0 1 1 0 3.125H16.667Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgImageUpload;
